/*!

=========================================================
* Light Bootstrap Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard-react.scss?v=1.3.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";

import AdminLayout from "layouts/Admin.jsx";
import firebase from 'firebase';
const config = {
  apiKey: "AIzaSyBLzDwhC91V74slaEl_AqLM6XX9Yaku02Y",
    authDomain: "mao-de-obra-sjc.firebaseapp.com",
    databaseURL: "https://mao-de-obra-sjc.firebaseio.com",
    projectId: "mao-de-obra-sjc",
    storageBucket: "mao-de-obra-sjc.appspot.com",
    messagingSenderId: "24432944660",
    appId: "1:24432944660:web:8f2f7b06dd8f612a396901",
    measurementId: "G-NL0V5E5YF6"
};
firebase.initializeApp(config);
ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/admin" render={props => <AdminLayout {...props} />} />
      <Redirect from="/" to="/admin/pedidos" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
